import { useEffect } from 'react';
import { ctGameDefault, ctGameTitle } from '../../constants/text';
import { PrivatePage } from '../../components/private-page';
import EventsManagementGrid from '../../features/events-management-grid';
export type dictionary = {
  id: number;
  name: string;
};

export default function EventsManagement() {
  useEffect(() => {
    document.title = ctGameTitle + ' - Events management';

    return () => {
      // return default value when component unmounts
      document.title = ctGameDefault;
    };
  }, []);

  return (
    <PrivatePage
      className={'page-base--full'}
      breadcrumb={[
        { label: 'Dashboard', href: 'dashboard' },
        { label: 'Administration', href: '../administration' },

        {
          label: 'Catalyst Portal Events',
          href: 'administration/events/manage'
        }
      ]}
      pageTitle={'Administration'}>
      <EventsManagementGrid />
    </PrivatePage>
  );
}
